/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import type { Task } from 'ember-concurrency';

interface CioAsyncModalSignature<T = void> {
  Element: HTMLDivElement;
  Args: {
    isOpen: boolean;
    onStart: () => Promise<T>;
    onClose: () => void;
    pendingTitle?: string;
    pendingVideo?: string;
    successTitle?: string;
    successVideo?: string;
    successText?: string;
    successRoute?: string;
    failureTitle?: string;
    failureVideo?: string;
    mediaContainerId?: string;
  };
  Blocks: {
    default: [promise: Task<undefined, [T]>];
  };
}

export default class CioAsyncModal<T = void> extends Component<CioAsyncModalSignature<T>> {}
